import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login, checking } = useAuth();
  const [email, setEmail] = useState("admin@thisthat.com");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (checking) return null;
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-4 py-20">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="w-14 h-14 mx-auto rounded-full bg-[#2C2924] flex items-center justify-center">
            <Lock className="w-6 h-6 text-[#D4AF37]" />
          </div>
          <h1 className="mt-6 font-serif text-4xl">Admin sign-in</h1>
          <p className="mt-2 text-sm text-[#5C5547]">Manage your shop, prompts and orders.</p>
        </div>
        <form onSubmit={submit} className="bg-[#FDFBF7] rounded-3xl p-8 border border-[#EAE4D3] shadow-sm space-y-4">
          <div>
            <label className="uppercase text-[10px] tracking-[0.2em] text-[#5C5547]">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="mt-2 w-full px-4 py-3 rounded-xl bg-[#F5F2EA] border border-[#EAE4D3] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm" />
          </div>
          <div>
            <label className="uppercase text-[10px] tracking-[0.2em] text-[#5C5547]">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="mt-2 w-full px-4 py-3 rounded-xl bg-[#F5F2EA] border border-[#EAE4D3] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm" />
          </div>
          {err && <div data-testid="admin-error" className="text-sm text-red-600">{err}</div>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full py-3.5 rounded-full bg-[#2C2924] text-[#FDFBF7] hover:bg-[#1A1815] text-sm disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
